export default {
  id: 'admin-dashboard',
  title: 'Admin Dashboard',
  category: 'Admin',
  summary: 'Operational overview with revenue charts and shortcuts into major admin areas.',
  overview: 'The dashboard gives administrators a snapshot of company activity and quick navigation into customers, contracts, projects, employees, and other admin modules.',
  howItWorks: [
    'Charts summarize year-to-date and monthly revenue where data is available.',
    'Shortcut tiles deep-link into common administrative lists.',
    'What you see depends on your admin permissions.'
  ],
  actions: [
    {
      name: 'Open a shortcut tile',
      description: 'Navigates to that admin area (customers, contracts, projects, employees, and so on).'
    },
    {
      name: 'Review charts',
      description: 'Use trends to spot billing or activity changes that may need follow-up in invoices or projects.'
    }
  ],
  tips: [
    'The dashboard is a launchpad — detailed work happens in each module’s list and detail pages.'
  ],
  related: ['customers', 'projects', 'invoices', 'reports']
};



// WEBPACK FOOTER //
// ./client/help/content/admin-dashboard.js